import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/$tab", params: { tab: "sms" }, replace: true });
  },
  component: () => null,
});
